import React, { useEffect, useState } from 'react'
import { Bar } from '@reactchartjs/react-chart.js'
import randomColor from 'randomcolor'

import Spinner from '~/components/Spinner'
import SmallScreenPlaceholder from '~/components/SmallScreenPlaceholder'
import { api, authHeaders } from '~/services/api'
import { Container } from './styles'

const barColors = Array.from({ length: 30 }).map(() => randomColor({
    luminosity: 25,
    hue: 'random'
}))

export default function () {
    const [enquetes, setEnquetes] = useState(null)
    const [data, setData] = useState(null)

    async function loadEnquetes() {
        try {
            const response = await api.get('enquete', authHeaders())

            setEnquetes(response)
        } catch (e) {
            toast.error(e.msg)
        }
    }

    async function loadData(enqueteId) {
        const response = await api.get(`enquete/${enqueteId}`, {
            params: {
                scope: 'estatistica'
            },
            ...authHeaders()
        })

        // const datasets = response.questoes.map((quest, idx) => ({
        //     label: `P${quest.identificador}`,
        //     backgroundColor: barColors[idx],
        //     data: quest.alternativas.map(alt => Math.random() * 10)
        // }))

        setData({
            labels: response.questoes.map(quest => `P${quest.identificador}`),
            datasets: response.questoes.map((_, idx) => ({
                label: String.fromCharCode(idx + 65),
                backgroundColor: barColors[idx],
                data: Array.from({ length: response.questoes.length }).map(() => Math.floor(Math.random() * 50))
            }))
        })
    }

    useEffect(() => {
        loadEnquetes()
    }, [])

    useEffect(() => {
        if (enquetes) {
            loadData(enquetes.at(-1).id)
        }
    }, [enquetes])

    if (!data) {
        return <Spinner />
    }

    return (
        <Container>
            {/* <FilterContainer>
                <div className='fields'>
                    <Select
                        withoutForm
                        id='canal'
                        onChange={setCanalSelecionado}
                        label='Canal de envio'
                        value={canalSelecionado}
                        options={[
                            { label: 'E-mail', value: 'email' },
                            { label: 'WhatsApp', value: 'whatsapp' }
                        ]}
                    />

                    <Calendar
                        withoutForm
                        label='Mês/ano'
                        dateFormat='mm/yy'
                        maxDate={new Date()}
                        view='month'
                        id='mes'
                        value={date}
                        onChange={e => {
                            setDate(e.value)
                        }}
                    />
                </div>
            </FilterContainer> */}

            <SmallScreenPlaceholder
                text="Gire o dispositivo para visualizar o gráfico."
                hideOffset={800}
            />

            <Bar
                data={data}
                options={{
                    responsive: true,
                    maintainAspectRatio: true,
                    legend: {
                        labels: {
                            fontColor: '#FFF'
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                fontColor: '#FFF',
                                // stepSize: 5,
                                beginAtZero: true
                            },
                            stacked: true
                        }],
                        xAxes: [{
                            ticks: {
                                fontColor: '#FFF',
                                stepSize: 1
                            },
                            stacked: true
                        }]
                    }
                }}
            />
        </Container>
    )
}
